import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./Services.css";

const Services = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/cover-overlay.jpg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>{rtl ? `خدماتنا` : fr ? "Nos Services" : `Our Services`}</h1>
        </div>
      </div>

      <div id="bodycont" class="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <strong>
                        {rtl
                          ? `شركاتنا`
                          : fr
                          ? "Nos Entreprises"
                          : `Our Companies`}
                      </strong>
                    </li>

                    <li>
                      <strong></strong>

                      <p class="mt05">
                        <Link to="/our-companies">
                          {rtl
                            ? `جولد بار الدولية المحدودة `
                            : fr
                            ? "Gold Bar International LTD"
                            : `Gold Bar International LTD`}
                        </Link>
                      </p>
                    </li>

                    <li>
                      <p class="mt05">
                        <Link to="/our-companies">
                          {rtl
                            ? `MMH & ABS المجموعة الهندسية`
                            : fr
                            ? "Groupe MMH & ABS Engineering"
                            : `MMH & ABS Engineering Group`}
                        </Link>
                      </p>
                    </li>

                    <li>
                      <p class="mt05">
                        <Link to="/our-companies">
                          {rtl
                            ? `بنك الاستثمار الإسلامي`
                            : fr
                            ? "Banque Islamique d'Investissement"
                            : `The Islamic Investment Bank`}
                        </Link>
                      </p>
                    </li>
                    {/* <li>
                                            <p class="mt05">
                                                <Link to="/our-companies">
                                                    King Fish Commodity Group
                                                </Link>
                                            </p>
                                        </li> */}
                    <li>
                      <p class="mt05">
                        <Link to="/our-companies">
                          {rtl
                            ? `البذور العالمية`
                            : fr
                            ? `Global Seeds`
                            : `Global Seeds`}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <p class="mt05">
                        <Link to="/our-companies">
                          {rtl
                            ? " زينوكس  للتكنولوجيا"
                            : fr
                            ? `Zeno X Tech`
                            : `Zeno X Tech`}
                        </Link>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </article>
            <article class="fluid three animated fadeInDown">
              <div class="col">
                {/* <h1>Our Services</h1> */}

                <p>&nbsp;</p>

                {/* <div class="right-box-prod-full">
                                    <h1>MMH</h1>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <img
                                            src={require("../../Assets/images/makkah.jpg")}
                                            class="imgleft rez"
                                        />

                                        <p>
                                            Seeks opportunities where investment
                                            in economic development programs
                                            will help rebuild countries, create
                                            jobs, and improve the quality of
                                            life for all. In this regard, MMH is
                                            currently focused on multiple
                                            countries in Africa with the
                                            objective of providing enhanced
                                            investments from its strategic
                                            partners in the Middle East, Europe
                                            and Southern Asia. Utilizing an
                                            innovative self-funding structure to
                                            launch development, investors enter
                                            the picture only after the initial
                                            research and design phases have been
                                            successfully completed.
                                        </p>
                                    </div>

                                    <p>&nbsp;</p>
                                </div> */}

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `أول عملة مشفرة`
                      : fr
                      ? "La Première Crypto-Monnaie"
                      : `The First Cryptocurrency`}
                  </h1>

                  <img
                    src={require("../../Assets/images/crypto2.png")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `قامت مكة  والمدينة القابضة  بتصميم أول عملة مشفرة سيتم دعمها من قبل البنوك المركزية الأفريقية. وباعتباره "العملة الشعبية"، سيتم استخدام هذا النظام على وجه التحديد للمساعدة في توسيع الاقتصادات الأفريقية. ستكون عملة مشفرة ستتمكن جميع الدول الأفريقية من استخدامها من خلال نظام رقمي لتسهيل تداول السلع في جميع أنحاء العالم.`
                      : fr
                      ? `MMH Banque a conçu la première crypto-monnaie qui sera
                      soutenue par les banques centrales africaines. En tant que
                      "monnaie du peuple", ce système sera utilisé spécifiquement
                      pour contribuer à l'expansion des économies africaines. Il s'agira
                      d'une crypto-monnaie que toutes les nations africaines pourront
                      utiliser par le biais d'un système numérique pour faciliter le
                      commerce des matières premières dans le monde entier.`
                      : ` MMH Has designed the first
                                        cryptocurrency which will be backed by
                                        the African central banks. As the
                                        “People’s Currency,” this system will be
                                        used specifically to help expand the
                                        African economies. It will be a
                                        cryptocurrency that all African nations
                                        will be able to use through a digital
                                        system to facilitate commodity trading
                                        around the globe.`}
                  </p>

                  <p>&nbsp;</p>
                </div>
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `مكتب السلع`
                      : fr
                      ? "Bureau des matières premières"
                      : `Commodity Desk`}
                  </h1>

                  <img
                    src={require("../../Assets/images/s-commodity.png")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `من أجل تلبية احتياجات عملائنا الحكوميين والتجاريين والأفراد بشكل أفضل، سيقدم بنك الاستثمار الإسلامي خدمات مكتب التداول للمعادن الثمينة والأحجار الكريمة والموارد الطبيعية الأخرى وكذلك العملات الأجنبية.`
                      : fr
                      ? `Afin de mieux répondre aux besoins de nos clients
                      gouvernementaux, commerciaux et individuels, la Banque
                      islamique d'investissement offrira des services de trading pour les
                      métaux précieux, les pierres précieuses et autres ressources
                      naturelles ainsi que pour les devises étrangères.`
                      : ` In order to better meet the needs of our
                                        government, commercial and individual
                                        clients, The Islamic investment Bank
                                        will offer trading desk services for
                                        precious metals, gemstones, and other
                                        natural resources as well as foreign
                                        currencies.`}
                  </p>

                  <p>&nbsp;</p>
                  <Link to="/commodity-desk">
                    <p class="button" style={{ marginTop: "10px" }}>
                      {rtl ? "إقرأ المزيد" : fr ? "Lire la suite" : `Read More`}
                    </p>
                  </Link>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `أفريقيا في عام 2023`
                      : fr
                      ? "L'AFRIQUE EN 2023"
                      : `Africa in 2023`}
                  </h1>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                    class="services-content"
                  >
                    <img
                      src={require("../../Assets/images/africa.jpg")}
                      class="imgleft rez"
                    />

                    <p>
                      {rtl
                        ? `وتتمثل الآلية الرئيسية لتنفيذ هذه البرامج الإنمائية في إنشاء أول بنك استثماري إسلامي دولي في أفريقيا. والغرض الأساسي منه هو تيسير تدفق الاستثمار الرأسمالي إلى البلدان الأفريقية مع زيادة سيولة المستثمرين وسلامتهم وثقتهم إلى أقصى حد.بصدد تشكيل اول بنك استثماري دولي اسلامي في غينيا.. 
 سيتم إنشاء بنوك إضافية في جميع أنحاء أفريقيا في عام 2023 تحت رعاية مكة  والمدينة القابضة  بالشراكة مع الحكومات الأفريقية وبنوكها المركزية مع المستثمرين الدوليين.`
                        : fr
                        ? `Le mécanisme clé pour la mise en œuvre de ces
                        programmes de développement est
                        l'établissement de la première banque
                        d'investissement islamique internationale en
                        Afrique. Son objectif premier est de faciliter les
                        flux d'investissements dans les pays africains tout
                        en maximisant la fluidité, la sécurité et la
                        confiance des investisseurs. La première banque
                        internationale d'investissement islamique va être
                        créée au Guinée. D'autres banques seront créées
                        dans toute l'Afrique en 2023 sous la garde de
                        MMH en partenariat avec les gouvernements
                        africains et leurs banques centrales avec des
                        investisseurs internationaux.`
                        : `The key mechanism for implementing
                                            these development programs is the
                                            establishment of the first
                                            international Islamic investment
                                            bank in Africa. Its primary purpose
                                            is to facilitate the flow of capital
                                            investment into African countries
                                            while maximizing investor fluidity,
                                            safety and confidence. The first islamic international investment bank will be launched in Guinea.
                                            Additional banks
                                            will be established throughout
                                            Africa in 2023 under the custody of
                                            MMH in partnership with the African
                                            governments and their central banks
                                            with international investors.`}
                    </p>
                  </div>

                  <p>&nbsp;</p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? ` الذهب والماس`
                      : fr
                      ? "OR ET DIAMANTS"
                      : `Gold & Diamonds`}
                  </h1>

                  <img
                    src={require("../../Assets/images/goldDiamond.jpg")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `ستقوم مكة  والمدينة القابضة   بتمويل مشاريع التنمية وكذلك التجارة في السلع الأساسية بما في ذلك الذهب والماس والفحم والعملات العالمية.`
                      : fr
                      ? `MMH financera des projets de développement
                      ainsi que le commerce de matières premières,
                      notamment l'or, les diamants, le charbon et les
                      devises mondiales.`
                      : `                                        MMH will fund development projects as
                                        well as trade in commodities including
                                        gold, diamonds, coal and world
                                        currencies.
`}{" "}
                  </p>

                  <p>&nbsp;</p>

                  <a name="healthcare">&nbsp;</a>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `هندسة النفط والغاز`
                      : fr
                      ? `INGÉNIERIE PÉTROLIÈRE ET GAZIÈRE`
                      : `Oil & Gas Engineering`}
                  </h1>

                  <img
                    src={require("../../Assets/images/oil&gas.jpg")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? ` كما سيجلب بنك مكة  والمدينة القابضة  تقنيات خاصة وموارد هندسية وخبرة إدارية وقدرات مبيعات / تسويق عبر شركائه الاستراتيجيين بما في ذلك  
 MMH & ABS المجموعة الهندسية
 وشركاء دوليين آخرين لضمان نجاح المشروع بشكل أفضل.`
                      : fr
                      ? `La MMH Banque apportera également des technologies
                      exclusives, des ressources en ingénierie, une expertise en
                      gestion et des capacités de vente et de marketing par
                      l'intermédiaire de ses partenaires stratégiques,
                      notamment ABS Oil & Gas Engineering et d'autres
                      partenaires internationaux, afin de mieux garantir la
                      réussite des projets.`
                      : ` The MMH Bank also will bring proprietary
                                        technologies, engineering resources,
                                        management expertise, and
                                        sales/marketing capabilities via its
                                        strategic partners including ABS Oil &
                                        Gas Engineering and other international
                                        partners to better ensure project
                                        success.`}
                  </p>

                  <p>&nbsp;</p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? ` المصانع والبنية التحتية`
                      : fr
                      ? "USINES ET INFRASTRUCTURES"
                      : `Plants & Infrastructure`}
                  </h1>
                  <img
                    src={require("../../Assets/images/plant.jpg")}
                    class="imgleft rez"
                  />
                  <p>
                    {rtl
                      ? `يدعم بنك مكة  والمدينة القابضة   تطوير العديد من محطات الوقود من الفحم إلى السائل والبنية التحتية اللازمة لدعم عمليات المحطات والموظفين وعائلاتهم وشركاء الأعمال`
                      : fr
                      ? `La MMH Banque soutient le développement de plusieurs
                      usines de transformation du charbon en combustible
                      liquide et l'infrastructure nécessaire pour soutenir les
                      opérations des usines, les employés et leurs familles, ainsi
                      que les partenaires commerciaux.`
                      : `The MMH bank Support the development of
                                        multiple Coal-toLiquid Fuel Plants and
                                        the infrastructure required to support
                                        the plants’ operations, employees and
                                        their families, and business partners
`}{" "}
                  </p>
                  <p>&nbsp;</p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? ` مدن الطاقة الذكي`
                      : fr
                      ? "VILLES INTELLIGENTES ET ÉNERGÉTIQUES"
                      : `Smart Energy Cities`}
                  </h1>

                  <img
                    src={require("../../Assets/images/smart-cities.jpg")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `وتمكن المدن الذكية المستدامة من التقدم عندما يتم توجيه دمج التكنولوجيا إلى نهج استراتيجي للتنمية المستدامة، ولكي تزدهر المدن الذكية، نحتاج إلى إنشاء نماذج تجارية مستدامة تسهل نجاح جميع الجهات الفاعلة في النظم الإيكولوجية.`
                      : fr
                      ? `Les villes durables et intelligentes permettent de
                     progresser lorsque l'intégration de la technologie est
                     orientée vers une approche stratégique du
                     développement durable. Pour que les villes intelligentes
                     prospèrent, nous devons établir des modèles
                     commerciaux durables qui facilitent la réussite de tous
                     les acteurs de l'écosystème.`
                      : `Sustainable, smart cities enable
                                        progress when the integration of
                                        technology is directed into a strategic
                                        approach to sustainable development and
                                        For smart cities to thrive, we need to
                                        establish sustainable commerce models
                                        that facilitate the success of all
                                        ecosystem players.`}
                  </p>
                  <Link to="/smart-cities">
                    <p class="button" style={{ marginTop: "10px" }}>
                      {rtl
                        ? "إقرأ المزيد"
                        : fr
                        ? "Lire la suite "
                        : `Read More`}
                    </p>
                  </Link>

                  <p>&nbsp;</p>
                </div>
                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `رؤية 2030 للحج والعمرة`
                      : fr
                      ? "VISION 2030 POUR LE HAJJ ET L'OMRAH"
                      : `2030 Vision for Hajj & Umrah`}
                  </h1>

                  <img
                    src={require("../../Assets/images/Umrah.jpg")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `ستقوم مكة  والمدينة القابضة   بالترويج لبرنامج سياحي للمسلمين المشاركين في الحج والعمرة في المملكة العربية السعودية ، والمساعدة في تطوير الأحداث والأماكن لإنشاء الدول الشريكة لنا كوجهات عالمية المستوى للمسافرين الدوليين الذين هم أيضا مستثمرون محتملون في مشاريع التنمية الاقتصادية`
                      : fr
                      ? `MMH promouvra un programme touristique pour les
                    musulmans s'engageant dans le Hajj et l'Omrah en
                    Arabie saoudite, et aidera à développer des événements
                    et des lieux pour établir nos pays partenaires comme des
                    destinations de classe mondiale pour les voyageurs
                    internationaux qui sont aussi des investisseurs potentiels
                    dans les projets de développement économique.`
                      : `MMH will promote a tourism program for
                                        Muslims engaging in Hajj and Umrah in
                                        Saudi Arabia, and help develop events
                                        and venues to establish our partner
                                        countries as world class destinations
                                        for international travelers who also are
                                        potential investors in the economic
                                        development projects.`}
                  </p>

                  <p>&nbsp;</p>
                </div>
                <div class="right-box-prod-full">
                  <h1>{rtl ? `بوابة` : fr ? "PORTE D'ENTREE" : `Gateway`}</h1>

                  <img
                    src={require("../../Assets/images/gateway.jpg")}
                    class="imgleft rez"
                  />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {rtl ? (
                      <p>
                        <span class="GTA"> بوابة إلى أفريقيا : </span>
                        كما يقول المثل ، "رحلة الألف ميل تبدأ بخطوة واحدة".
                        وبالنسبة للبنك الإسلامي للاستثمار، تحدد كل خطوة جوهر ما
                        نقدره بوابة
                        <br />
                        <span class="GTA"> آسيا : </span>
                        العمرة هي رحلة روحية جميلة يقوم بها كل مسلم للاعتراف
                        بالله (سبحان الله تعالى – المجد له، تعالى) كنذير السلام
                        والتواصل معه لتطهير الشوائب في الداخل..
                      </p>
                    ) : fr ? (
                      <p>
                        <span class="GTA">Porte d'entrée à l'Afrique : </span>{" "}
                        Comme le dit le proverbe, "un voyage de mille lieues
                        commence par un seul pas". Et pour la Banque islamique
                        d'investissement, chaque pas définit l'essence de ce que
                        nous valorisons.
                        <br />
                        <span class="GTA">
                          La porte d'entrée à l'Asie :{" "}
                        </span>{" "}
                        L'Omrah est un magnifique voyage spirituel entrepris par
                        chaque musulman pour reconnaître Allah (Subhanahu Wa
                        Ta'ala - Gloire à lui, l'exalté) comme l'annonciateur de
                        la paix et pour communier avec lui afin de purger les
                        impuretés à l'intérieur...
                      </p>
                    ) : (
                      <p>
                        <span class="GTA">Gateway to Africa : </span> As the
                        sayin, goes, “a journey of a thousand miles begins with
                        a single step.” And for The Islamic investment Bank,
                        each step defines the essence of what we value
                        <br />
                        <span class="GTA">Gateway to Asia : </span> Umrah is a
                        beautiful spiritual journey taken by every single Muslim
                        to acknowledge Allah (Subhanahu Wa Ta’ala – Glory to
                        him, the exalted) as the harbinger of peace and to
                        commune with him to purge the impurities within..
                      </p>
                    )}
                    <Link to="/gateway-africa-asia">
                      <p class="button" style={{ marginTop: "10px" }}>
                        {rtl
                          ? "إقرأ المزيد"
                          : fr
                          ? "Lire la suite"
                          : `Read More`}
                      </p>
                    </Link>
                  </div>
                  <p>&nbsp;</p>
                </div>

                <div class="right-box-prod-full">
                  <h1>
                    {rtl
                      ? `المؤسسة الخيرية`
                      : fr
                      ? "Fondation De Charité"
                      : `Charity Foundation`}
                  </h1>

                  <img
                    src={require("../../Assets/images/charityy.jpg")}
                    class="imgleft rez"
                  />

                  <p>
                    {rtl
                      ? `بنك الاستثمار الإسلامي مصدر مفتوح للأعمال الخيرية`
                      : fr
                      ? `La Banque islamique d'investissement est une
                      source ouverte pour la charité`
                      : `The Islamic investment Bank is an open
                                        source for charity`}
                  </p>

                  <p>&nbsp;</p>
                </div>
                {/* <div class="right-box-prod-full">
                                    <h1>Digital Payment System</h1>
                                    <img
                                        src={require("../../Assets/images/charity.jpg")}
                                        class="imgleft rez"
                                    />
                                    <p>
                                        The Islamic investment Bank is an open
                                        source for charity
                                    </p>
                                    <p>&nbsp;</p>
                                </div> */}
                <p>&nbsp;</p>

                <div class="addthis_native_toolbox"></div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
